// extracted by mini-css-extract-plugin
module.exports = {"searchItems":"index_searchItems__wK2vk","form":"index_form__JNQ66"};